<template>
  <div id="app" :dir="$i18n.locale == 'en' ? 'ltr':'rtl'" :class="theme" class="content-wrapper bg-background-primary">

    <Navbar @dataForApp="updateValue"/>


    <div v-if="startFalsh" class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center" style="z-index:100">
      <div class="text-6xl text-white">
        musab mohammed
      </div>
    </div>


    <div id="title" class="pt-48">
      <div class="over">
        <div class="wow fadeInUp text-white w-3/5 absolute flex flex-col items-center justify-center text-center" data-wow-delay=".3s">
          
            <h1 class="tracking-wider text-xl md:text-2xl lg:text-4xl font-bold mb-5">{{ $t('title.0') }}</h1>
            <span class="w-full text-lg sm:text-xl md:text-2xl lg:text-4xl text-center mt-4"><span class="ityped"/></span>
            <a href="mailto:m.hard268@email.com"> 
              <button class="text-xs md:text-sm uppercase tracking-wider bg-white rounded px-6 py-2 text-gray-700 font-bold mt-8 focus:outline-none">{{ $t('title.2') }}</button>
            </a>
          
        </div>
      </div>        
    </div>

    <div id="aboutMe" class="flex justify-center">
        <div id="aboutMeSub" class="wow pulse flex flex-col my-32 text-mytext-primary" data-wow-delay=".3s" data-wow-duration="1.5s">
            <span class="w-full text-xl md:text-3xl lg:text-4xl px-5 sm:px-10 font-extrabold text-center">{{ $t('aboutMe.1') }}</span>
            <span class="flex justify-center mt-5 px-10 tracking-wider">
                <div class="w-full md:max-w-lg text-sm text-center">{{ $t('aboutMe.2') }}</div>
            </span>
        </div>
    </div>
    
    
    <MyExperiences />


    <Paragraphs />


    <NumbersAboutMe />


    <RecentWork />

  
    <Slider />



    

    <div id="workWithMe" class="flex justify-center -mb-20 mt-32">
      <div class="w-full mx-8 bg-gradient rounded flex flex-col lg:flex-row justify-between py-8 px-10 shadow-xl items-center text-center text-white wow fadeInUp" data-wow-delay=".3s">
          
          <span class="text-2xl lg:text-3xl font-semibold tracking-wide">{{ $t('workWithMe.start') }}</span>
          <span class="text-gray-100 text-lg  my-4 lg:my-0 max-w-lg">
              {{ $t('workWithMe.interested') }}
          </span>
          <a href="mailto:m.hard268@email.com" class="px-6 py-2 text-xl lg:text-lg border-2 border-white font-semibold rounded-full hover:bg-white hover:text-myblue">
              {{ $t('workWithMe.doThis') }}
          </a>
          
      </div>
    </div>
    
    <Footer />

    
  </div>
</template>

<script>
import Navbar from '@/components/layouts/Navbar'
import Footer from '@/components/layouts/Footer'
import MyExperiences from './components/MyExperiences'
import RecentWork from './components/RecentWork'
import Slider from './components/Slider'
import NumbersAboutMe from './components/NumbersAboutMe'
import Paragraphs from './components/Paragraphs'

import $ from 'jquery'
import 'jquery.nicescroll'
import Typed from 'typed.js'
import {WOW} from 'wowjs'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    MyExperiences,
    RecentWork,
    Slider,
    NumbersAboutMe,
    Paragraphs
  },
  data() {
    return {
      strings:[
        this.$i18n.t('title.1_0'),
        this.$i18n.t('title.1_1'),
        this.$i18n.t('title.1_2'),
        this.$i18n.t('title.1_3'),
        this.$i18n.t('title.1_4'),
      ],
      typed:null,
      theme:'',
      startFalsh:true
    }
  },
  created() {
    setTimeout(() => {
      this.startFalsh = false
    }, 3000);
  },
  mounted() {
    $('html').niceScroll({
      cursorcolor:'#008fb3',
      cursorwidth:"7px",
      cursorborderradius:50,
      cursorborder:'1px solid #008fb3',
      zindex: 49
    });
    this.typed = new Typed('.ityped', {
      showCursor:true,
      strings: this.strings,
      typeSpeed: 70,
      backSpeed: 50,
      backDelay: 800,
      startDelay: 1000,

      loop: true
    });

    var options={
        offset: 0,
        delay:10,
        live: false,
        callback:function(box) {
          console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
        }
    };
    new WOW(options).init()
  },
  methods: {
      updateValue(value){
          this.theme = value
      }
  },
  computed: {
    langLocaleNow(){
      return this.$i18n.locale
    }
  },
  watch: {
    langLocaleNow(){
      Object.assign(this.$data.strings,this.$options.data.call(this).strings)
      this.typed.strings = this.strings
      this.typed.reset()
    }
  },
}
</script>


<style>
  @import './assets/css/Home.css';
  @import './assets/font-awesome/css/font-awesome.min.css';
  @import './assets/css/animate.css';
    #title{
          background-image: url('./assets/img/lap.jpg');
          background-position: center center;
          background-attachment: fixed;
          background-size: cover;
          position: relative;
          height: 95vh;
          width: 100%;
    }
    .over{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background:linear-gradient(to top,rgba(0, 143, 179, .8),rgba(153, 235, 255, .8));
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    #title:before ,.over:before{
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;            
            height: 200px;
            width: 100%;
            transition: background-color .8s;
            background: var(--bg-background-primary);
            clip-path: polygon(100% 70%,0 100%,100% 100%);
    }
    .typed-cursor{
      font-size: 32px;
    }
</style>
